(() => {
  if (window.__elementWaterButtons) return;
  window.__elementWaterButtons = true;

  const SELECTOR = [
    '.button:not(.button--close)',
    '.element-about__button',
    '.element-business__button',
    '.element-warranty-page__button',
    '.element-tracking__button',
    '.element-terms__button',
    '.element-returns__button',
    '.element-shipping__button',
    '.element-privacy__button',
    '.element-home-v2__button',
    '.element-home-v2__add',
    '.element-guarantee-page__button',
    '.element-app__button',
    '.element-support-faq__contact-button',
    '.element-sticky-product-bar__button',
    '.element-cart-checkout__button',
    '.element-cart-payments__action',
    '.element-ambassador__form-footer button[type="submit"]',
    '.contact-page__step-actions button:not(.contact-page__back)',
    '.contact-page__form-footer button[type="submit"]',
    '.contact-page__channels article > a',
    '.contact-page__channels article > button',
    '.product-page__add',
    '.element-water-btn',
    '.element-colour-copy__cart'
  ].join(',');

  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CAN_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const DURATION = 600;
  const REST = 'translate3d(0, 100%, 0)';
  const COVER = 'translate3d(0, 0, 0)';
  const EXIT = 'translate3d(0, -76%, 0)';

  function parseRgb(value) {
    if (!value || value === 'transparent') return null;
    const parts = value.match(/(\d+(?:\.\d+)?)/g);
    if (!parts || parts.length < 3) return null;
    return {
      r: Number(parts[0]),
      g: Number(parts[1]),
      b: Number(parts[2]),
      a: parts[3] === undefined ? 1 : Number(parts[3])
    };
  }

  function luminance(rgb) {
    const toLinear = (channel) => {
      const value = channel / 255;
      return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * toLinear(rgb.r) + 0.7152 * toLinear(rgb.g) + 0.0722 * toLinear(rgb.b);
  }

  function contrastInk(fillColor, restBg) {
    const fill = parseRgb(fillColor);
    const buttonBg = parseRgb(restBg);
    const fillLum = fill && fill.a > 0.2 ? luminance(fill) : 1;

    if (fillLum > 0.55) {
      if (buttonBg && buttonBg.a > 0.2 && luminance(buttonBg) < 0.5) {
        return `rgb(${Math.round(buttonBg.r)}, ${Math.round(buttonBg.g)}, ${Math.round(buttonBg.b)})`;
      }
      return '#1b1d1a';
    }

    return '#fff';
  }

  function shouldSkipNode(node) {
    if (node.nodeType !== 1) return false;
    return (
      node.classList.contains('btn-fill') ||
      node.hasAttribute('data-fill') ||
      node.classList.contains('btn-surface') ||
      node.classList.contains('btn-wave-edge') ||
      node.classList.contains('element-sticky-product-bar__loader') ||
      node.hasAttribute('data-hero-buy-loader') ||
      node.hasAttribute('data-explore-cta-loader')
    );
  }

  function fillFor(button) {
    let fill = button.querySelector(':scope > [data-fill], :scope > .btn-fill');
    if (fill) return fill;

    fill = document.createElement('span');
    fill.className = 'btn-fill';
    fill.setAttribute('data-fill', '');
    fill.setAttribute('aria-hidden', 'true');
    button.insertBefore(fill, button.firstChild);
    return fill;
  }

  function surfaceFor(button, restBg) {
    let surface = button.querySelector(':scope > .btn-surface');
    if (!surface) {
      surface = document.createElement('span');
      surface.className = 'btn-surface';
      surface.setAttribute('aria-hidden', 'true');
      button.insertBefore(surface, button.firstChild);
    }
    if (restBg) surface.style.backgroundColor = restBg;
    return surface;
  }

  function wrapLabel(button) {
    const existing = button.querySelector(':scope > .btn-text');
    if (existing) return existing;

    const label = document.createElement('span');
    label.className = 'btn-text';
    const nodes = Array.from(button.childNodes).filter((node) => !shouldSkipNode(node));
    nodes.forEach((node) => label.appendChild(node));
    button.appendChild(label);
    return label;
  }

  function paintInk(button, label, active) {
    const ink = active
      ? button.style.getPropertyValue('--btn-wave-ink') || '#1b1d1a'
      : '';
    const targets = [button, label, ...label.querySelectorAll('*')];
    targets.forEach((el) => {
      if (active) el.style.setProperty('color', ink, 'important');
      else el.style.removeProperty('color');
    });
  }

  function bind(button) {
    // Finish buttons own their changing surface and persistent light animation.
    if (button.hasAttribute('data-colour-add-to-cart')) return;
    if (button.dataset.waterBound === 'true') return;
    if (button.classList.contains('button--close')) return;

    const restBg = getComputedStyle(button).backgroundColor;
    const restRgb = parseRgb(restBg);
    if (restRgb && restRgb.a > 0.2 && luminance(restRgb) > 0.7) {
      button.classList.add('element-water-btn--light');
    }

    const fill = fillFor(button);
    const fillColor = getComputedStyle(fill).backgroundColor;
    surfaceFor(button, restBg);
    const label = wrapLabel(button);

    button.classList.add('element-water-btn');
    button.dataset.waterBound = 'true';
    fill.style.transform = REST;
    button.style.setProperty('--btn-rest-bg', restBg);
    button.style.setProperty('--btn-wave-fill', fillColor);
    button.style.setProperty('--btn-wave-ink', contrastInk(fillColor, restBg));
    button.style.setProperty('background', 'none', 'important');
    button.style.setProperty('background-color', 'transparent', 'important');

    if (REDUCE || !CAN_HOVER) return;

    const hoverRoot = button.closest('[data-water-hover]') || button;
    let leaveTimer;

    function isIdle(target) {
      return (
        target.disabled ||
        target.getAttribute('aria-disabled') === 'true' ||
        target.classList.contains('is-disabled') ||
        target.classList.contains('is-loading')
      );
    }

    hoverRoot.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      if (isIdle(button)) return;
      window.clearTimeout(leaveTimer);
      paintInk(button, label, true);
      fill.style.transition = `transform ${DURATION}ms cubic-bezier(0.22, 1, 0.36, 1)`;
      fill.style.transform = COVER;
    });

    hoverRoot.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      paintInk(button, label, false);
      fill.style.transition = `transform ${DURATION}ms cubic-bezier(0.22, 1, 0.36, 1)`;
      fill.style.transform = EXIT;
      leaveTimer = window.setTimeout(() => {
        fill.style.transition = 'none';
        fill.style.transform = REST;
      }, DURATION);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(bind);
  }

  scan();
  document.addEventListener('page:loaded', () => scan());
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
